<div id="download-wrapper">
  <header>
    <h1>{{ 'download.downloadLabel' | cxTranslate }}</h1>
  </header>
  <div id="download-body-wrapper">
    <div id="download-left-menu-wrapper">
      <app-download-media-category-list
        *ngIf="downLoadItems$ | async as downLoadItems"
        (getDownloadCategry)="getDownloadCategry($event)"
        [items]="downLoadItems"
      ></app-download-media-category-list>
    </div>
    <div id="download-category-wrapper">
      <div class="download-media-wrapper">
        <app-download-media *ngIf="items$ | async as items" [items]="items"></app-download-media>
      </div>
      <div id="pagination-wrapper-component">
        <app-pagination
          (viewPageEvent)="pageChange($event)"
          [pagination]="PaginationModel"
          [hideOnSinglePage]="true"
        ></app-pagination>
      </div>
    </div>
  </div>
</div>
